import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0983581f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "subscription-banner"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "topbar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-coins me-1" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "fa fa-spin fa-spinner"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-fw fa-sign-out" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSubscriptionBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.subscriptionBannerText), 1),
          (_ctx.subscriptionEndText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.subscriptionEndText), 1))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToSubscriptionPage && _ctx.goToSubscriptionPage(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.subscriptionBannerLinkText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'apps-store' })))
      }, _hoisted_6),
      _hoisted_7,
      (_ctx.hasBusinessUnit)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'credits' },
            custom: ""
          }, {
            default: _withCtx(({ navigate, isActive }) => [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-transparent credits-balance", { active: isActive }]),
                title: _ctx.creditsLoadError ? 'Credits unavailable' : 'View credit balance and lots',
                onClick: navigate
              }, [
                _hoisted_9,
                (_ctx.creditsLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.creditsBalanceLabel), 1))
              ], 10, _hoisted_8)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/logout",
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _createElementVNode("button", {
            class: "btn btn-transparent",
            onClick: navigate
          }, _hoisted_14, 8, _hoisted_12)
        ]),
        _: 1
      })
    ])
  ]))
}